import { gql } from "@apollo/client";

export const listSegments = gql`
  query ListSegments($filter: SegmentFilter) {
    listSegments(filter: $filter) {
      id
      name
      population
      attributes
      attributeValues
      type
      rules
      status
    }
  }
`;

export const loadSegment = gql`
  query LoadSegment($id: String!) {
    loadSegment(id: $id) {
      id
      name
      brandId
      categoryId
      programId
      population
      attributes
      attributeValues
      type
      rules
      status
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`;
export const listProfilesBySegment = gql`
  query ListProfilesBySegment($segmentId: ID!, $page: Int!, $size: Int!) {
    listProfilesBySegment(segmentId: $segmentId, page: $page, size: $size) {
      total
      items {
        id
        userId
        userInfo {
          firstName
          lastName
          emailAddress
          phone
          nationalId
        }
      }
    }
  }
`;
